import * as PIXI from "pixi.js";
import { PINK_ANGLE_COLORS } from "../../../../interactive-tools/circle-theorem-10/src/game/types/Config";


const RULER_HEIGHT = 128;
const CM_UNIT = 60;
const CM_LINE_HEIGHT = 30;
const GRADUATIONS_OFFSET = 20;

const getRulerWidth = (cmAmount: number) => cmAmount * CM_UNIT + GRADUATIONS_OFFSET * 2;


export default class RulerRendererFactory {
  static getGraduationCoord(i: number, cmAmount: number, isBack: boolean) {
    const w = getRulerWidth(cmAmount);
    return {
      x: -w / 2 + CM_UNIT * i + GRADUATIONS_OFFSET,
      y:  isBack ? RULER_HEIGHT / 2 + 2 : -RULER_HEIGHT / 2
    }
  }
  static drawBg(bg: PIXI.Graphics, cmAmount: number){
    const w = getRulerWidth(cmAmount);
    const h = RULER_HEIGHT;
    bg
      .moveTo(-w / 2, -h / 2)
      .roundRect(-w / 2, -h / 2, w, h, 10)
      .fill({ color: PINK_ANGLE_COLORS[0], alpha: .6 })
  }
  static drawNumbers(numbers: PIXI.Text[],  cmAmount: number) {
    const w = getRulerWidth(cmAmount)
    const startX = -w / 2;
    const y = -RULER_HEIGHT / 2
    
    numbers.forEach((num, number) => {
      num.text = number;
      num.anchor.set(.5);
      num.x = startX + CM_UNIT * number + GRADUATIONS_OFFSET;
      num.y = y + CM_LINE_HEIGHT + 12;
      num.style.fontSize = 20;
    });
  }
  static drawgraduations(graduations: PIXI.Graphics, cmAmount: number) {
    const w = getRulerWidth(cmAmount);
    Array(cmAmount + 1).fill(null).forEach((_, i) => {
      // START Drawing CMs
      const { x, y } = this.getGraduationCoord(i, cmAmount, false)
      graduations
        .moveTo(x, y)
        .lineTo(x, y + CM_LINE_HEIGHT);
      // END Drawing CMs
      if(i < cmAmount) {
        // START Drawing MM lines in between CMs
        const unitMMX = CM_UNIT / 10;
        Array(10).fill(null).forEach((_, mi) => {
          const mmX = x + unitMMX * (mi + 1);
          const mmY = y + (CM_LINE_HEIGHT / 3) * (mi == 4 ?  2 : 1)
          graduations
            .moveTo(mmX, y)
            .lineTo(mmX, mmY)
        })
        // END Drawing MM lines in between CMs
      }
    })
    graduations.stroke({ width: 1, color: 0x000000 })
  }
  static drawFlipButton(flipButton: PIXI.Graphics) {
    const coord = { x: 0, y: 9 };

    flipButton
      .moveTo(coord.x, coord.y)
      .circle(coord.x, coord.y, 25)
      .fill({ color: 0xff0000, alpha: 0 })

      .moveTo(coord.x - 8, coord.y - 6)
      .lineTo(coord.x + 8, coord.y - 6)
      .lineTo(coord.x, coord.y + 6)
      .lineTo(coord.x - 8, coord.y - 6)

      .fill(0x333333);
  }
  static drawRotateButton(rotateButton: PIXI.Graphics, isLeft: boolean, cmAmount: number) {
    const totalW = getRulerWidth(cmAmount);
    const w = GRADUATIONS_OFFSET + CM_UNIT;
    const startX = isLeft ? -totalW / 2 : totalW / 2 - w;
    const startY = -RULER_HEIGHT / 2;

    rotateButton
      .moveTo(startX, startY)
      .roundRect(startX, startY, w, RULER_HEIGHT, 10)
      .fill({ color: 0x000000, alpha: 0 });
  }
  static drawGrabButton(grabButton: PIXI.Graphics, cmAmount: number) {
    const totalW = getRulerWidth(cmAmount);
    const offsetW = GRADUATIONS_OFFSET + CM_UNIT;
    const w = totalW - 2 * offsetW;
    const h = -RULER_HEIGHT / 2;
    const startX = -totalW / 2 + offsetW;

    grabButton
      .moveTo(startX, h)
      .rect(startX, h, w, RULER_HEIGHT)
      .fill({ color: 0xff0000, alpha: 0 })
  }
  static drawDrawingArea(drawingArea: PIXI.Graphics , cmAmount: number, isBack: boolean ) {
    const totalW = getRulerWidth(cmAmount) - 2 * GRADUATIONS_OFFSET;
    const h = RULER_HEIGHT / 4;
    const startY = isBack ? h * 2 : -h * 3;

    drawingArea
      .moveTo(-totalW / 2, startY)
      .rect(-totalW / 2, startY, totalW, h)
      .fill({ color: 0xff0000, alpha: 0 })
  }
}